export const HIDE_EMAIL_SIGN_IN_SUCCESS_MODAL          = "HIDE_EMAIL_SIGN_IN_SUCCESS_MODAL";
export const HIDE_EMAIL_SIGN_IN_ERROR_MODAL            = "HIDE_EMAIL_SIGN_IN_ERROR_MODAL";
export const HIDE_OAUTH_SIGN_IN_SUCCESS_MODAL          = "HIDE_OAUTH_SIGN_IN_SUCCESS_MODAL";
export const HIDE_OAUTH_SIGN_IN_ERROR_MODAL            = "HIDE_OAUTH_SIGN_IN_ERROR_MODAL";
export const HIDE_SIGN_OUT_ERROR_MODAL                 = "HIDE_SIGN_OUT_ERROR_MODAL";
export const HIDE_SIGN_OUT_SUCCESS_MODAL               = "HIDE_SIGN_OUT_SUCCESS_MODAL";
export const HIDE_EMAIL_SIGN_UP_SUCCESS_MODAL          = "HIDE_EMAIL_SIGN_UP_SUCCESS_MODAL";
export const HIDE_EMAIL_SIGN_UP_ERROR_MODAL            = "HIDE_EMAIL_SIGN_UP_ERROR_MODAL";
export const SHOW_FIRST_TIME_LOGIN_SUCCESS_MODAL       = "SHOW_FIRST_TIME_LOGIN_SUCCESS_MODAL";
export const HIDE_FIRST_TIME_LOGIN_SUCCESS_MODAL       = "HIDE_FIRST_TIME_LOGIN_SUCCESS_MODAL";
export const HIDE_PASSWORD_RESET_SUCCESS_MODAL         = "HIDE_PASSWORD_RESET_SUCCESS_MODAL";
export const SHOW_PASSWORD_RESET_SUCCESS_MODAL         = "SHOW_PASSWORD_RESET_SUCCESS_MODAL";
export const SHOW_FIRST_TIME_LOGIN_ERROR_MODAL         = "SHOW_FIRST_TIME_LOGIN_ERROR_MODAL";
export const HIDE_FIRST_TIME_LOGIN_ERROR_MODAL         = "HIDE_FIRST_TIME_LOGIN_ERROR_MODAL";
export const HIDE_PASSWORD_RESET_ERROR_MODAL           = "HIDE_PASSWORD_RESET_ERROR_MODAL";
export const SHOW_PASSWORD_RESET_ERROR_MODAL           = "SHOW_PASSWORD_RESET_ERROR_MODAL";
export const HIDE_REQUEST_PASSWORD_RESET_SUCCESS_MODAL = "HIDE_REQUEST_PASSWORD_RESET_SUCCESS_MODAL";
export const HIDE_REQUEST_PASSWORD_RESET_ERROR_MODAL   = "HIDE_REQUEST_PASSWORD_RESET_ERROR_MODAL";
export const HIDE_UPDATE_PASSWORD_SUCCESS_MODAL        = "HIDE_UPDATE_PASSWORD_SUCCESS_MODAL";
export const HIDE_UPDATE_PASSWORD_ERROR_MODAL          = "HIDE_UPDATE_PASSWORD_ERROR_MODAL";
export const HIDE_DESTROY_ACCOUNT_SUCCESS_MODAL        = "HIDE_DESTROY_ACCOUNT_SUCCESS_MODAL";
export const HIDE_DESTROY_ACCOUNT_ERROR_MODAL          = "HIDE_DESTROY_ACCOUNT_ERROR_MODAL";


export function hideEmailSignInSuccessModal() {
  return { type: HIDE_EMAIL_SIGN_IN_SUCCESS_MODAL };
}
export function hideEmailSignInErrorModal() {
  return { type: HIDE_EMAIL_SIGN_IN_ERROR_MODAL };
}
export function hideOAuthSignInSuccessModal() {
  return { type: HIDE_OAUTH_SIGN_IN_SUCCESS_MODAL };
}
export function hideOAuthSignInErrorModal() {
  return { type: HIDE_OAUTH_SIGN_IN_ERROR_MODAL };
}
export function hideSignOutSuccessModal() {
  return { type: HIDE_SIGN_OUT_SUCCESS_MODAL };
}
export function hideSignOutErrorModal() {
  return { type: HIDE_SIGN_OUT_ERROR_MODAL };
}
export function hideEmailSignUpSuccessModal() {
  return { type: HIDE_EMAIL_SIGN_UP_SUCCESS_MODAL };
}
export function hideEmailSignUpErrorModal() {
  return { type: HIDE_EMAIL_SIGN_UP_ERROR_MODAL };
}
export function showFirstTimeLoginSuccessModal() {
  return { type: SHOW_FIRST_TIME_LOGIN_SUCCESS_MODAL };
}
export function showPasswordResetSuccessModal() {
  return { type: SHOW_PASSWORD_RESET_SUCCESS_MODAL };
}
export function hideFirstTimeLoginSuccessModal() {
  return { type: HIDE_FIRST_TIME_LOGIN_SUCCESS_MODAL };
}
export function hidePasswordResetSuccessModal() {
  return { type: HIDE_PASSWORD_RESET_SUCCESS_MODAL };
}
export function showFirstTimeLoginErrorModal() {
  return { type: SHOW_FIRST_TIME_LOGIN_ERROR_MODAL };
}
export function showPasswordResetErrorModal() {
  return { type: SHOW_PASSWORD_RESET_ERROR_MODAL };
}
export function hideFirstTimeLoginErrorModal() {
  return { type: HIDE_FIRST_TIME_LOGIN_ERROR_MODAL };
}
export function hidePasswordResetErrorModal() {
  return { type: HIDE_PASSWORD_RESET_ERROR_MODAL };
}
export function hidePasswordResetRequestSuccessModal() {
  return { type: HIDE_REQUEST_PASSWORD_RESET_SUCCESS_MODAL };
}
export function hidePasswordResetRequestErrorModal() {
  return { type: HIDE_REQUEST_PASSWORD_RESET_ERROR_MODAL };
}
export function hideUpdatePasswordSuccessModal() {
  return { type: HIDE_UPDATE_PASSWORD_SUCCESS_MODAL };
}
export function hideUpdatePasswordErrorModal() {
  return { type: HIDE_UPDATE_PASSWORD_ERROR_MODAL };
}
export function hideDestroyAccountSuccessModal() {
  return { type: HIDE_DESTROY_ACCOUNT_SUCCESS_MODAL };
}
export function hideDestroyAccountErrorModal() {
  return { type: HIDE_DESTROY_ACCOUNT_ERROR_MODAL };
}



// WEBPACK FOOTER //
// ./src/actions/ui.js